// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../img/Vector-e.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../img/Vector-w.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../img/Vector-g.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GeneralNotification_container_top__an73u {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 7rem;
  width: 100%;
  border-bottom: 1px solid #9898AB;
}
.GeneralNotification_container_row__Xwmz4 {
  display: grid;
  grid-template-columns: 4rem 1fr 1rem;
  padding: 2rem 0.5rem;
  gap: 1rem;
}
.GeneralNotification_container_row__Xwmz4:hover {
  background-color: var(--color-grey-5);
}
.GeneralNotification_container_lowStock__eHow8 {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--color-primary-8);
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
}
.GeneralNotification_container_lowStock__img__J-jIK {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.GeneralNotification_container_outOfStock__zQ4J- {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--color-light-red);
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
}
.GeneralNotification_container_outOfStock__img__vCpXw {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.GeneralNotification_container_success__px1cv {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--color-green-3);
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
}
.GeneralNotification_container_success__img__F8yKe {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.GeneralNotification_container_read__q\\+BNU {
  display: flex;
  align-items: center;
  border-radius: 50%;
  justify-content: center;
  width: 1rem;
  height: 1rem;
  background-color: var(--color-primary);
}
.GeneralNotification_container_time__9xi2t {
  font-size: 10px;
  color: var(--color-grey);
}

.GeneralNotification_readAll__cS4nW {
  font-size: 1.5rem;
  cursor: pointer;
}
.GeneralNotification_readAll__cS4nW:hover {
  transform: translateX(2px);
  transition: transform 0.2s ease-out;
  color: var(--color-primary);
}

.GeneralNotification_icon__MOJTm {
  height: 2.4rem;
}

.GeneralNotification_iconWrapper__OBVtU {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--color-primary-8);
  border-radius: 50%;
  width: 4rem;
  height: 4rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/GeneralNotification/GeneralNotification.module.scss"],"names":[],"mappings":"AAGC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,gCAAA;AAFF;AAKC;EACC,aAAA;EACA,oCAAA;EACA,oBAAA;EACA,SAAA;AAHF;AAKE;EACC,qCAAA;AAHH;AAOC;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wCAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AALF;AAOE;EACC,gDAAA;AALH;AAUC;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wCAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AARF;AAUE;EACC,gDAAA;AARH;AAaC;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sCAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAXF;AAaE;EACC,gDAAA;AAXH;AAgBC;EACC,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,sCAAA;AAdF;AAiBC;EACC,eAAA;EACA,wBAAA;AAfF;;AAmBA;EACC,iBAAA;EACA,eAAA;AAhBD;AAkBC;EACC,0BAAA;EACA,mCAAA;EACA,2BAAA;AAhBF;;AAoBA;EACC,cAAA;AAjBD;;AAoBA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AAjBD","sourcesContent":["@import '../variables/breakpoints';\n\n.container {\n\t&_top {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\theight: 7rem;\n\t\twidth: 100%;\n\t\tborder-bottom: 1px solid #9898AB;\n\t}\n\n\t&_row {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 4rem 1fr 1rem;\n\t\tpadding: 2rem .5rem;\n\t\tgap: 1rem;\n\n\t\t&:hover {\n\t\t\tbackground-color: var(--color-grey-5);\n\t\t}\n\t}\n\n\t&_lowStock {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tbackground-color: var(--color-primary-8);\n\t\twidth: 4rem;\n\t\theight: 4rem;\n\t\tborder-radius: 50%;\n\n\t\t&__img {\n\t\t\tcontent: url(../../img/Vector-e.png);\n\t\t}\n\n\t}\n\n\t&_outOfStock {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tbackground-color: var(--color-light-red);\n\t\twidth: 4rem;\n\t\theight: 4rem;\n\t\tborder-radius: 50%;\n\n\t\t&__img {\n\t\t\tcontent: url(../../img/Vector-w.png);\n\t\t}\n\n\t}\n\n\t&_success {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tbackground-color: var(--color-green-3);\n\t\twidth: 4rem;\n\t\theight: 4rem;\n\t\tborder-radius: 50%;\n\n\t\t&__img {\n\t\t\tcontent: url(../../img/Vector-g.png);\n\t\t}\n\n\t}\n\n\t&_read {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tborder-radius: 50%;\n\t\tjustify-content: center;\n\t\twidth: 1rem;\n\t\theight: 1rem;\n\t\tbackground-color: var(--color-primary);\n\t}\n\n\t&_time {\n\t\tfont-size: 10px;\n\t\tcolor: var(--color-grey);\n\t}\n}\n\n.readAll {\n\tfont-size: 1.5rem;\n\tcursor: pointer;\n\n\t&:hover {\n\t\ttransform: translateX(2px);\n\t\ttransition: transform 0.2s ease-out;\n\t\tcolor: var(--color-primary);\t\t\n\t}\n}\n\n.icon {\n\theight: 2.4rem;\n}\n\n.iconWrapper {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tbackground-color: var(--color-primary-8);\n\tborder-radius: 50%;\n\twidth: 4rem;\n\theight: 4rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container_top": `GeneralNotification_container_top__an73u`,
	"container_row": `GeneralNotification_container_row__Xwmz4`,
	"container_lowStock": `GeneralNotification_container_lowStock__eHow8`,
	"container_lowStock__img": `GeneralNotification_container_lowStock__img__J-jIK`,
	"container_outOfStock": `GeneralNotification_container_outOfStock__zQ4J-`,
	"container_outOfStock__img": `GeneralNotification_container_outOfStock__img__vCpXw`,
	"container_success": `GeneralNotification_container_success__px1cv`,
	"container_success__img": `GeneralNotification_container_success__img__F8yKe`,
	"container_read": `GeneralNotification_container_read__q+BNU`,
	"container_time": `GeneralNotification_container_time__9xi2t`,
	"readAll": `GeneralNotification_readAll__cS4nW`,
	"icon": `GeneralNotification_icon__MOJTm`,
	"iconWrapper": `GeneralNotification_iconWrapper__OBVtU`
};
export default ___CSS_LOADER_EXPORT___;
